// Custom subscription script to replicate Palo Alto's old subscription functionality
!function() {
    "use strict";

    if (!document.querySelector('input[name="selling-plan-group"]')) return;

    let lastVariantId = null;
    let cachedProduct = null;

    const syncSellingPlanInput = (planId) => {
        const form = document.querySelector('.shopify-product-form');
        if (!form) return;
        let hiddenInput = form.querySelector('input[name="selling_plan"]');
        if (!hiddenInput) {
            hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'selling_plan';
            form.appendChild(hiddenInput);
        }
        hiddenInput.value = planId || '';
    };

    const openCollapsible = (el) => {
        const height = el.scrollHeight;
        el.style.height = `${height}px`;
        requestAnimationFrame(() => el.classList.add('is-expanded'));

        el.addEventListener('transitionend', function onEnd(e) {
            if (e.propertyName === 'height') {
                el.style.height = 'auto';
                el.removeEventListener('transitionend', onEnd);
            }
        });
    };

    const closeCollapsible = (el) => {
        const height = el.scrollHeight;
        el.style.height = `${height}px`;
        el.classList.remove('is-expanded');

        requestAnimationFrame(() => {
            el.style.height = '0px';
        });
    };

    const getSelectedVariant = async () => {
        const productInfo = document.querySelector('product-info');
        if (!productInfo) return null;
        
        if (!cachedProduct) {
            const response = await fetch(productInfo.dataset.url + '.js');
            cachedProduct = await response.json();
        }
        
        const productForm = document.querySelector('product-form[data-variant-price]');
        const currentPrice = parseInt(productForm?.dataset.variantPrice);
        
        return cachedProduct.variants.find(v => v.price === currentPrice) || cachedProduct.variants[0];
    };

    const subPriceUpdate = (e) => {
        const variant = e.data.variant;
        if (!variant) return;

        const variantChanged = lastVariantId !== null && lastVariantId !== variant.id;
        lastVariantId = variant.id;
        
        if (variantChanged) {
            const oneTimePurchaseRadio = document.querySelector('input[name="selling-plan-group"][value=""]');
            if (oneTimePurchaseRadio && !oneTimePurchaseRadio.checked) {
                oneTimePurchaseRadio.checked = true;
                oneTimePurchaseRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        const selectedPlanGroup = document.querySelector('input[name="selling-plan-group"]:checked');
        const hasPlanSelected = selectedPlanGroup && selectedPlanGroup.value !== '';
        
        const priceWrappers = document.querySelectorAll('[data-price-wrapper]');
        
        priceWrappers.forEach((wrap) => {
            const comparePriceEl = wrap.querySelector('[data-compare-price]');
            const productPriceEl = wrap.querySelector('[data-product-price]');
            
            let comparePrice = variant.compare_at_price;
            let price = variant.price;
            
            if (hasPlanSelected && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
                const allocation = variant.selling_plan_allocations[0];
                price = allocation.per_delivery_price;
                
                if (variant.price > allocation.per_delivery_price) {
                    comparePrice = variant.price;
                }
            }
            
            const formatPrice = (val) => {
                return window.theme?.formatMoney 
                    ? window.theme.formatMoney(val, theme.moneyFormat) 
                    : (val / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            };
            
            if (productPriceEl) {
                productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : formatPrice(price);
            }
            
            if (comparePriceEl) {
                const showCompare = (comparePrice && comparePrice > price);
                
                if (showCompare) {
                    comparePriceEl.classList.remove('is-collapsed');
                    productPriceEl.classList.add('product__price--sale');
                    comparePriceEl.innerHTML = formatPrice(comparePrice);
                } else {
                    comparePriceEl.classList.add('is-collapsed');
                    productPriceEl.classList.remove('product__price--sale');
                }
            }
        });
        
        const productForm = e.target?.querySelector('.product-single .product__block[data-form-wrapper]') 
            || document.querySelector('.product-single .product__block[data-form-wrapper]');

        if (productForm) {
            const oneTimeEl = productForm.querySelectorAll('[data-one-time-price]');
            const discountEl = productForm.querySelectorAll('[data-discount-price]');
            const variantPrice = variant.price;
            const discountPrice = variant.selling_plan_allocations?.[0]?.per_delivery_price;

            const formatPriceCustom = (val) => {
                return (val / 100).toLocaleString('en-US', {
                    style: 'currency', 
                    currency: 'USD'
                });
            };

            oneTimeEl.forEach(priceEl => {
                priceEl.innerText = formatPriceCustom(variantPrice);
            });

            if (discountPrice) {
                discountEl.forEach(priceEl => {
                    priceEl.innerText = formatPriceCustom(discountPrice);
                });
            }
        }
    };

    const handlePlanGroupChange = async (e) => {
        const val = e.target.value.toString();
        const selected = document.querySelector(`[data-group-toggle="${val}"]`);
        const groups = document.querySelectorAll('[data-group-toggle]');
        const description = document.querySelector('[data-plan-description]');

        if (selected) {
            openCollapsible(selected);
            const first = selected.querySelector('[name="selling_plan"]');
            if (first) {
                first.checked = true;
                first.dispatchEvent(new Event('change'));
                syncSellingPlanInput(first.value);
            }
        } else {
            syncSellingPlanInput('');
        }

        groups.forEach((group) => {
            if (group !== selected) {
                closeCollapsible(group);
                const plans = group.querySelectorAll('[name="selling_plan"]');
                plans.forEach((plan) => {
                    plan.checked = false;
                    plan.dispatchEvent(new Event('change'));
                });
            }
        });

        if (description) {
            val ? openCollapsible(description) : closeCollapsible(description);
        }

        const currentVariant = await getSelectedVariant();
        if (currentVariant) {
            subPriceUpdate({ data: { variant: currentVariant } });
        }
    };

    let subscriptionId = null;
    const initSubscription = async () => {
        const currentVariant = await getSelectedVariant();
        if (currentVariant) {
            lastVariantId = currentVariant.id;
        }
        
        if (subscriptionId && window.unsubscribe) {
            window.unsubscribe(subscriptionId);
        }
        
        if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
            subscriptionId = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, subPriceUpdate);
        }
        
        const planGroupRadios = document.querySelectorAll('input[name="selling-plan-group"]');
        planGroupRadios.forEach(radio => {
            radio.addEventListener('change', handlePlanGroupChange);
        });
    };

    document.addEventListener("DOMContentLoaded", initSubscription);
    document.addEventListener('shopify:section:load', initSubscription);
}();


// Overlapping images our story page
const refreshParallax = () => {
    const overlappingImages = document.querySelector('.overlapping-images');
    if(!overlappingImages) return;
    requestAnimationFrame(() => {
        document.dispatchEvent(new Event('theme:resize'));
        document.dispatchEvent(new Event('theme:parallax:refresh'));
    });
};

window.addEventListener('load', refreshParallax);
window.addEventListener('pageshow', refreshParallax);